import { ReferralMessage } from './referralmessage';

export class ReferralDetail {
    public referralCode: string = '';
    public eventName: string = '';
    public referralURL: string = '';
    public appShareInfo: string = '';
    public referralMessages: ReferralMessage[] = [];
}
